import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://docs.google.com/spreadsheets/d/1y1N-_at6dlV-n1HSlsesMpDx8xKd7O-NNw-UKmCv0e0/edit#gid=985197945&range=B20",
  target: "_blank"
}, "Xem hướng dẫn", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: _ctx.$t('screenTitle.siteConfig')
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_collapse, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_collapse_panel, { header: "Cài đặt khuyến mãi khi chuyển BẠC CHÍNH vào game" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                ref: "formPromotionTransInfo",
                model: _ctx.formModelPromotionTransInfo,
                onFinish: _ctx.onFinishPromotionTransInfo,
                rules: _ctx.formRulePromotionTransInfo,
                scrollToFirstError: true,
                layout: "vertical"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "Tỉ lệ (%)",
                    name: "rate"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_number, {
                        value: _ctx.formModelPromotionTransInfo.rate,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formModelPromotionTransInfo.rate) = $event)),
                        min: 1
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "Phạm vi thời gian",
                    name: "range"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_range_picker, {
                        value: _ctx.formModelPromotionTransInfo.range,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formModelPromotionTransInfo.range) = $event)),
                        "show-time": ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        "html-type": "submit",
                        block: "",
                        loading: _ctx.isLoadingPromotionTransInfo
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('text.save')), 1)
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "onFinish", "rules"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_collapse_panel, { header: "Cài đặt phiên bản client Game.exe" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                ref: "formGameExeVer",
                model: _ctx.formModelGameExeVer,
                onFinish: _ctx.onFinishGameExeVer,
                rules: _ctx.formRuleGameExeVer,
                scrollToFirstError: true,
                layout: "vertical"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "Mã phiên bản",
                    name: "value"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.formModelGameExeVer.value,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formModelGameExeVer.value) = $event)),
                        placeholder: "06 85 00 00"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        "html-type": "submit",
                        block: "",
                        loading: _ctx.isLoadingGameExeVer
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('text.save')), 1)
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "onFinish", "rules"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_collapse_panel, { header: "Cài link tải game" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                ref: "formDlUrls",
                model: _ctx.formModelDlUrls,
                onFinish: _ctx.onFinishDlUrls,
                rules: _ctx.formRuleDlUrls,
                scrollToFirstError: true,
                layout: "vertical"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "Các địa chỉ tải game",
                    name: "value",
                    help: "Mỗi địa chỉ cách nhau 1 dòng"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_textarea, {
                        value: _ctx.formModelDlUrls.value,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formModelDlUrls.value) = $event)),
                        rows: 5,
                        placeholder: "Google 1|http://google.com/xxx"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        "html-type": "submit",
                        block: "",
                        loading: _ctx.isLoadingDlUrls
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('text.save')), 1)
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "onFinish", "rules"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_collapse_panel, { header: "Liên kết Server Game" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_table, {
                dataSource: _ctx.dataSourceServers,
                columns: _ctx.columnsServers,
                pagination: false,
                loading: _ctx.isLoadingServers
              }, {
                bodyCell: _withCtx(({ column, record }) => [
                  (column.key === 'action')
                    ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            danger: "",
                            onClick: () => _ctx.onDeleteServer(record)
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_DeleteOutlined)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024))
                    : (column.dataIndex === 'allow_unlock_char')
                      ? (_openBlock(), _createBlock(_component_a_checkbox, {
                          key: 1,
                          checked: record.allow_unlock_char,
                          "onUpdate:checked": ($event: any) => ((record.allow_unlock_char) = $event),
                          onChange: () => _ctx.onServerChangeUnlock(record)
                        }, null, 8, ["checked", "onUpdate:checked", "onChange"]))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["dataSource", "columns", "loading"]),
              _createVNode(_component_a_collapse, { ghost: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_collapse_panel, { header: "Liên kết máy chủ Game mới" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_alert, null, {
                        description: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form, {
                        ref: "formCreateServer",
                        model: _ctx.formModelCreateServer,
                        onFinish: _ctx.onFinishCreateServer,
                        rules: _ctx.formRuleCreateServer,
                        scrollToFirstError: true,
                        layout: "vertical"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "Tên máy chủ",
                            name: "name"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _ctx.formModelCreateServer.name,
                                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formModelCreateServer.name) = $event))
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_form_item, {
                            label: "db_host",
                            name: "db_host"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _ctx.formModelCreateServer.db_host,
                                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formModelCreateServer.db_host) = $event))
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_form_item, {
                            label: "db_port",
                            name: "db_port"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input_number, {
                                value: _ctx.formModelCreateServer.db_port,
                                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formModelCreateServer.db_port) = $event)),
                                min: 1,
                                max: 65535
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_form_item, {
                            label: "db_user",
                            name: "db_user"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _ctx.formModelCreateServer.db_user,
                                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formModelCreateServer.db_user) = $event))
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_form_item, {
                            label: "db_pass",
                            name: "db_pass"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _ctx.formModelCreateServer.db_pass,
                                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formModelCreateServer.db_pass) = $event))
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_form_item, {
                            label: "db_name",
                            name: "db_name"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _ctx.formModelCreateServer.db_name,
                                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formModelCreateServer.db_name) = $event))
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_form_item, {
                            label: "login_port",
                            name: "login_port"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input_number, {
                                value: _ctx.formModelCreateServer.login_port,
                                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formModelCreateServer.login_port) = $event)),
                                min: 1,
                                max: 65535
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_form_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                type: "primary",
                                "html-type": "submit",
                                block: "",
                                loading: _ctx.isLoadingServers
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('text.save')), 1)
                                ]),
                                _: 1
                              }, 8, ["loading"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model", "onFinish", "rules"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_collapse_panel, { header: "Cài đặt thời gian đua top chuyển BẠC CHÍNH vào game" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                ref: "formTopTransRange",
                model: _ctx.formModelTopTransRange,
                onFinish: _ctx.onFinishTopTransRange,
                rules: _ctx.formRuleTopTransRange,
                scrollToFirstError: true,
                layout: "vertical"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "Phạm vi thời gian",
                    name: "value"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_range_picker, {
                        value: _ctx.formModelTopTransRange.value,
                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formModelTopTransRange.value) = $event)),
                        "show-time": ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        "html-type": "submit",
                        block: "",
                        loading: _ctx.isLoadingTopTransRange
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('text.save')), 1)
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "onFinish", "rules"]),
              _createVNode(_component_a_table, {
                columns: [{ title: 'Tên tài khoản', dataIndex: 'accname' }, { title: 'Bạc', dataIndex: 'coin'}],
                "data-source": _ctx.topTransferToTlbb,
                loading: _ctx.isLoadingTopTrans
              }, {
                title: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    loading: _ctx.isLoadingTopTrans,
                    onClick: _ctx.fetchTopTransferTlbb
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Load lại danh sách top")
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"])
                ]),
                _: 1
              }, 8, ["data-source", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}